export default "__VITE_ASSET__f4e6af97__"